'use client';
import { Button } from '@/components/ui/button';
import useCurrency from '@/hooks/useCurrency';
import { Currency } from '@/lib/currency';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

export function NavbarCurrencySwitcher({
  variant = 'outline',
  color,
}: {
  variant?: 'outline' | 'ghost';
  color: 'black' | 'white';
}) {
  const { setCurrency, currencies, selectedCurrencyObject } = useCurrency();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className={cn(
            'flex gap-2 rounded-full font-extrabold md:border md:border-2',
            color === 'black' ? 'text-black border-black' : 'text-white border-white',
            variant === 'ghost' && 'border-none'
          )}
        >
          <span className="text-base">{selectedCurrencyObject?.flag}</span>
          <span className="hidden md:block font-black">{selectedCurrencyObject?.code}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {currencies.map((currencyOption: Currency) => (
          <DropdownMenuItem
            key={currencyOption.code}
            onClick={() => setCurrency(currencyOption.code)}
            className="cursor-pointer font-bold"
          >
            <span>
              {currencyOption.flag} {currencyOption.code} - {currencyOption.name}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
